import { render, staticRenderFns } from "./VerticalMenuBar.vue?vue&type=template&id=82db451c&scoped=true"
import script from "./VerticalMenuBar.vue?vue&type=script&lang=ts"
export * from "./VerticalMenuBar.vue?vue&type=script&lang=ts"
import style0 from "./VerticalMenuBar.vue?vue&type=style&index=0&id=82db451c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82db451c",
  null
  
)

export default component.exports